// extracted by mini-css-extract-plugin
export default {"link":"SearchPage_link__R59NT","data":"SearchPage_data__Bzm2f","details":"SearchPage_details__Nfhvk"};